import React, { useState, useEffect } from 'react';
import { useAuth } from '../lib/auth';
import { useApi } from '../lib/apiClient'; // <-- IMPORT THE AXIOS CLIENT HOOK
import { User } from '../lib/auth/types';

// Define expected response structure for clarity
type AdminUsersResponse = {
    success: boolean;
    users?: User[];
    message?: string;
} | User[]; // Allow for direct array response too

export default function UserManagementPage() {
  const { isAdmin } = useAuth(); // Removed getToken as interceptor handles it
  const api = useApi(); // <-- GET THE AXIOS API CLIENT INSTANCE
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      if (!isAdmin) {
        setError('Access Denied.');
        setLoading(false);
        return;
      }

      // No need to manually get token here

      try {
        setLoading(true);
        setError(null);
        console.log("Attempting to fetch /admin/users");

        // Use the axios client's get method
        // Interceptor will add the token
        const response = await api.get<AdminUsersResponse>('/admin/users');

        console.log("Response from /admin/users:", response); // Log the direct response data

        // Adjust based on actual API response structure
        if (response && Array.isArray(response)) {
            // Direct array response
            setUsers(response);
        } else if (response && response.success && Array.isArray(response.users)) {
            // Object response with success flag and users array
            setUsers(response.users);
        } else {
          throw new Error(response?.message || 'Failed to fetch users or unexpected format');
        }
      } catch (err: any) {
        console.error("Error fetching users:", err);
        const message = err.response?.data?.message || err.message || 'An error occurred while fetching users.';
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [isAdmin, api]); // Add api as dependency

  if (loading) {
    return <div>Loading users...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }

  return (
    <div>
      <h1>User Management</h1>
      {users.length === 0 ? (
        <p>No users found or API endpoint not ready.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>User Type</th>
              <th>Firebase UID</th>
              <th>Internal ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.uid || user.id}>
                <td>{user.email || 'N/A'}</td>
                <td>{user.user_type || 'N/A'}</td>
                <td>{user.uid || 'N/A'}</td>
                <td>{user.id || 'N/A'}</td>
                <td>
                  <button disabled>Edit</button> {/* Placeholder */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}